import { gsap } from 'gsap/dist/gsap';
import { searchLightboxes } from '../components/search'
import { buttonScrollDown } from '../animation/button-scroll-down'
import { triggerPlusPlanLightbox, numberOfUsersControl, createPlusPlanCheckout } from '../components/pricing-table'

export default {
  init() {
        
    buttonScrollDown()
    triggerPlusPlanLightbox()
    numberOfUsersControl()
    createPlusPlanCheckout()
    searchLightboxes()

    /**************************************************************
    -> Launch search lightbox when search button is clicked
    **************************************************************/
    function saveItemsLightbox() {

      const button = document.querySelector('.view-saved-items')

      if (button) {
        const lightbox = document.querySelector('.saved-items-lightbox')
        const closeTriggers = Array.from(lightbox.querySelectorAll('[data-lightbox-close]'))
        
        button.addEventListener('click', () => {
          document.body.style.overflow = 'hidden'
          gsap.to(lightbox, { opacity: 1, pointerEvents: 'all'})
        })
        
        closeTriggers.forEach(close => {
          close.addEventListener('click', () => {
            document.body.style.overflow = 'initial'
            gsap.to(lightbox, { opacity: 0, pointerEvents: 'none'})
          })
        })

      }

    }

    saveItemsLightbox()

  },
}


// WEBPACK FOOTER //
// ./scripts/routes/page-my-account-data.js